
import React, { useEffect, useState, useRef } from "react";
import TextInput from '/src/components/UI/TextField/TextInput';
import "./DashboardVariableFormModal.css"
import CheckBox from "/src/components/UI/CheckBox/CheckBox"
import Dropdown from "/src/components/UI/DropDown/DropDown"
import useDropdownDashboard from "../../../hooks/useDropdownDashboard"
import { checkNumber } from "../../../checkNumber";
import { getIconByType } from '../../../variableType';
import { DashboardVariableType } from '../../../variableType';
import { useForm } from "react-hook-form";
import generateKey from '/src/utils/generateKey';
const DashboardVariableCondition = ({ condition, variables, hookBlocks, block }) => {

    const { removeCondition, modifyCondition } = hookBlocks
    const ref = useRef();
    const [variable, setVariable] = useState(condition.variable);
    const [listVariableDropdown, setListVariableDropdown] = useState([]);
    const { register, getValues, setValue } = useForm({
        mode: "onChange",
        defaultValues: {
            value: condition.value ?? variable.default_value,
        }
    })

    const { dropdownDefaultValue, modifyDropdownValues } = useDropdownDashboard(variable.placeholder_format); // inutile si le type   n est pas la dropdown

    const updateCondition = (value, _variable = variable) => {
        condition.variable = _variable;
        modifyCondition(block.index, condition,  value);
        setValue("value", value);
    }
    
    const getVariableById = (id) => variables.find(v => v.id == id);

    const setUpVariablesListDropdown = () => {
        let _variables = variables.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))

        let list = _variables.map((variable) => {
            return {
                value: variable.id,
                text: <span style={{ justifyContent: 'start', maxWidth: "200px" }} title={variable.label}> {getIconByType(variable.type)}{variable.label} </span>
            }
        })
        if (list.length == 0){
            return; // si pas de variable, pas besoin d'aller plus loin
        }
        setListVariableDropdown([...list])
    }

    const updateCurrentVariable = (value) => {
        let _variable = getVariableById(value)
        if (variable != _variable) {
            setVariable(_variable)
        }
        console.log(variable)
        console.log(_variable)
        if (_variable.type == 2) {
            modifyDropdownValues(_variable.placeholder_format)
        }
        modifyCurrentVariableDefaultValue(_variable);
        /*
        if (variable.type != _variable.type) {
            modifyCurrentVariableDefaultValue(_variable);

        }*/
    }

    useEffect(() => {
        setUpVariablesListDropdown()
    }, [variable])


    const modifyCurrentVariableDefaultValue = (_variable) => {
        //let currentVal = getValues("value") 
        switch (_variable.type) {
            case DashboardVariableType.find(type => type.name == "Toggle").value:
                // updateCondition(getValues("value") != null ? parseInt(getValues("value")) : false, _variable);
                updateCondition(false , _variable);
                break;
            case DashboardVariableType.find(type => type.name == "Input").value:
                //updateCondition(currentVal != null ? currentVal : "", _variable);
                updateCondition("", _variable);
                break;
            case DashboardVariableType.find(type => type.name == "Dropdown").value:
                modifyDropdownValues(_variable.placeholder_format)
                //updateCondition(currentVal != null ? parseInt(currentVal) : 0, _variable);
                updateCondition(0, _variable);
                break;
            case DashboardVariableType.find(type => type.name == "Number").value:
                updateCondition(0, _variable);
                //updateCondition(currentVal != null ? parseInt(currentVal) : 0, _variable);
                break;
            default:
                return 'foo';
        }
    }
    const renderListVariable = listVariableDropdown.length > 0 && <Dropdown key={generateKey()} reverse={true} choices={listVariableDropdown} defaultChoice={variable.id} width="200px" setValue={(name, value) => updateCurrentVariable(value)} ></Dropdown>

    const renderDelete = <i key={generateKey()} className="fas fa-trash remove_condition_block_dashboard_variable_icon" style={{ color: "var(--pink)" }} onClick={() => { setValue("value", null); removeCondition(block.index, condition.index) }}></i>

    return (
        <div className="container_block_condition_dashboard" style={{ border: "0px", marginTop: variable?.type == 2 ? "-15px" : "" }} key={generateKey()}>
            {
                listVariableDropdown.length > 0 &&
                <div>
                    {
                        variable?.type == 0 &&
                        <div className="checkbox_dashboard_variable_container" style={{ margin: "0" }} >
                            <div className={"list_variables_choose_dropdown"} key={generateKey()}>
                                {renderListVariable}
                            </div>
                            <div>
                                <CheckBox ref={ref} key={generateKey()} name={generateKey() + " dashboard_variable_condition_value"} onChange={() => updateCondition(! parseInt(getValues("value")))} checked={parseInt(getValues("value"))}></CheckBox>
                            </div>
                            {renderDelete}
                        </div>
                    }
                    {
                        variable?.type == 1 &&
                        <div className="input_dashboard_variable_container">
                            <div className={"list_variables_choose_dropdown"} key={generateKey()}>
                                {renderListVariable}
                            </div>
                            <TextInput ref={ref} {...register("value")} key={generateKey()} placeholder="Conditional value" className={"input_conditionnal_block_dashboard_variable"} onChange={(e) => updateCondition(e.target.value)} ></TextInput>
                            {renderDelete}
                        </div>
                    }
                    {
                        variable?.type == 2 && dropdownDefaultValue.length > 0 &&
                        <div className={"dropdown_container dropdown_dashboard_variable_container conditional_dropdown"}>
                            <div>
                                {renderListVariable}
                            </div>
                            <div style={{ marginLeft: "10px" }} className={"selector_dropdown_variable_cond"}>
                                <Dropdown ref={ref} id={"dashboard_variable_condition_value"} key={generateKey()} reverse={true} choices={dropdownDefaultValue} defaultChoice={getValues("value")} width="190px" setValue={(name, value) => { updateCondition(value) }} ></Dropdown>
                            </div>
                            <div style={{ position: "relative", bottom: "-5px" }}>{renderDelete}  </div>

                        </div>
                    }
                    {
                        variable?.type == 4 &&
                        <div className="input_dashboard_variable_container">
                            <div className={"list_variables_choose_dropdown"} key={generateKey()}>
                                {renderListVariable}
                            </div>
                            <TextInput ref={ref} key={generateKey()} type="number" onKeyDown={(e) => checkNumber(e)} defaultValue={getValues("value")} placeholder="Conditional number" className={"input_variable_dashboard_form input_conditionnal_block_dashboard_variable"} onChange={(e) => updateCondition(e.target.value)} />
                            {renderDelete}
                        </div>
                    }
                </div>

            }
        </div>
    )
}
export default DashboardVariableCondition